import type { GoalImpact } from "@/src/features/api/ChatApi";
import type { OnboardingV3PlanImpact } from "./onboardingV3Types";

const FITNESS_DIMENSIONS = new Set<
  OnboardingV3PlanImpact["dimensions"][number]
>(["control", "safety", "growth"]);

export function normalizePlanImpact(
  raw: GoalImpact | undefined,
): OnboardingV3PlanImpact | null | undefined {
  if (raw === null) {
    return null;
  }
  if (!raw) {
    return undefined;
  }

  const delta = raw.delta ?? 0;
  const dimensions = (raw.dimensions ?? []).filter(
    (dimension): dimension is OnboardingV3PlanImpact["dimensions"][number] =>
      FITNESS_DIMENSIONS.has(
        dimension as OnboardingV3PlanImpact["dimensions"][number],
      ),
  );

  return { delta, dimensions };
}
